import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-primary-400 text-2xl"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-50">香蕉漫画网</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              香蕉漫画网汇聚海量漫画免费阅读资源，免费漫画大全免费看漫画免费更新一应俱全，零成本畅享全本漫画。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4">
              <a href="/category/rexue" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors flex items-center gap-1.5 cursor-pointer"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors">快速链接</Link>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/rexue" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="/category/rexue" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">热门排行</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-50/60">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line"></i>
                </span>
                <span>contact@bananamanga.com</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-customer-service-line"></i>
                </span>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-shield-check-line"></i>
                </span>
                <span>安全阅读 · 无广告干扰</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} 香蕉漫画网 - 漫画免费阅读与免费漫画大全。本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            <a href="/about" className="hover:text-primary-400 transition-colors">免责声明</a>
            <a href="/about" className="hover:text-primary-400 transition-colors">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}